<template>
  <AnalyticsAiChatTab
    :messages="messages"
    :thinking="isThinking"
    :suggestedQuestions="suggestedQuestions ?? []"
    @send="sendMessage"/>
</template>

<script setup lang="ts">
import {onMounted, ref} from 'vue';
import type {IAnalyticsAiChatMessage} from '@torim-app/types';

import AnalyticsAiChatTab from './AnalyticsAiChatTab.vue';
import {AiApi} from '@app/api/admin/ai-api';
import {trackEvent} from '@app/composables/posthog';

// The chat session lives inside this drawer component — closing the drawer
// unmounts it (useDrawer remounts fresh via drawerKey), so the session ends there.
const props = defineProps<{
  initialMessage?: string;
  suggestedQuestions?: string[];
}>();

const messages = ref<IAnalyticsAiChatMessage[]>([]);
const isThinking = ref(false);

const sendMessage = async (question: string) => {
  if (isThinking.value) return;
  trackEvent('analytics_ai_chat_message_sent');
  const history = [...messages.value];
  messages.value.push({role: 'user', content: question});
  isThinking.value = true;
  try {
    // no range — the backend grounds drawer chats in the last 30 days
    const res = await AiApi.sendAnalyticsChatMessage({
      message: question,
      conversationHistory: history,
    });
    messages.value.push({role: 'assistant', content: res.reply});
  } catch (e) {
    console.error(e);
    messages.value.push({role: 'assistant', content: 'משהו השתבש בדרך. נסו לשלוח שוב.'});
  } finally {
    isThinking.value = false;
  }
};

onMounted(() => {
  if (props.initialMessage) sendMessage(props.initialMessage);
});
</script>
